const keywordToAction = {
    'show-and-hide': 'show_hide_field',
    'update-calculate': 'calculate_field',
    'enable-require': 'require_field',
    'skip': 'go_to_page',
    'thankyou': 'thank_you_page',
    'email-recipient': 'change_email_recipient',
  };
  
  // Reverse mapping
  const actionToKeyword = Object.entries(keywordToAction).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});
  
  // Get right value from left key
  export const getActionFromKeyword = (keyword) => keywordToAction[keyword] || null;
  
  // Get left key from right value
  export const getKeywordFromAction = (action) => actionToKeyword[action] || null;
  